import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemDescriptionItem} from '@github-ui/list-view/ListItemDescriptionItem'
import {ListItemLeadingVisual} from '@github-ui/list-view/ListItemLeadingVisual'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import {getIconColorClassName, getIconComponent} from '@github-ui/saved-views'
import {CopyIcon, KebabHorizontalIcon, TrashIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton, RelativeTime} from '@primer/react'
import {memo} from 'react'

import styles from './RepositoryViews.module.css'
import type {SavedView} from './types'

type ViewRowProps = {
  view: SavedView
  owner: string
  repo: string
}

function ViewRowComponent({view, owner, repo}: ViewRowProps) {
  const viewUrl = `/${owner}/${repo}/issues/views/${view.id}`

  return (
    <ListItem
      title={<ListItemTitle value={view.name} href={viewUrl} />}
      role="listitem"
      className={styles.viewRow}
      secondaryActions={
        <div className={styles.viewActions}>
          <ActionMenu>
            <ActionMenu.Anchor>
              <IconButton icon={KebabHorizontalIcon} aria-label={`${view.name} options`} variant="invisible" />
            </ActionMenu.Anchor>
            <ActionMenu.Overlay width="small">
              <ActionList>
                <ActionList.Item disabled>
                  <ActionList.LeadingVisual>
                    <CopyIcon />
                  </ActionList.LeadingVisual>
                  Duplicate
                </ActionList.Item>
                <ActionList.Item disabled variant="danger">
                  <ActionList.LeadingVisual>
                    <TrashIcon />
                  </ActionList.LeadingVisual>
                  Delete
                </ActionList.Item>
              </ActionList>
            </ActionMenu.Overlay>
          </ActionMenu>
        </div>
      }
    >
      <ListItemLeadingVisual
        className={`${styles.viewLeadingVisual} ${getIconColorClassName(view.color)}`}
        icon={getIconComponent(view.icon)}
      />
      <ListItemMainContent>
        <ListItemDescription>
          <ListItemDescriptionItem>
            {view.creatorLogin ? <span>Created by {view.creatorLogin} &bull; </span> : null}
            <span>
              Last updated <RelativeTime datetime={view.updatedAt} />
            </span>
          </ListItemDescriptionItem>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}

export const ViewRow = memo(ViewRowComponent)
